import {
  ReturnShipmentDataResponse,
  SetShipmentAsReturnPayload,
} from '../../types/SetShipmentAsReturn'
import { api } from './api'

export const returnsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    setShipmentAsReturn: builder.mutation<unknown, SetShipmentAsReturnPayload>({
      query: (params) => ({
        url: '/collection/functions/returns',
        method: 'POST',
        body: {
          shipmentId: params.shipmentId,
          optimizationTourId: params.optimizationTourId,
        },
      }),
      invalidatesTags: ['ShipmentsForReturn'],
    }),
    getReturnShipmentRequests: builder.query<
      Array<ReturnShipmentDataResponse>,
      Array<number>
    >({
      query: (shipmentIds) => ({
        url: '/collection/functions/returns/fetch-requests',
        method: 'POST',
        body: shipmentIds,
      }),
      providesTags: ['ShipmentsForReturn'],
    }),
  }),
})

export const {
  useGetReturnShipmentRequestsQuery,
  useSetShipmentAsReturnMutation,
} = returnsApi
